import React, { useState, useRef, useEffect } from 'react';
import '../../css/vers2/SideMenu.css';

type SideMenuProps = {
    setPage: React.Dispatch<React.SetStateAction<string>>;
};

const SideMenu = ({ setPage }: SideMenuProps) => {
    const [open, setOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const goToPage = (page: string) => {
        setPage(page);
        setOpen(false);
    };

    // 👇 klik buiten menu = sluiten
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);

    return (
        <nav className="side-menu" ref={menuRef}>
            <button className="menu-icon" type="button" onClick={() => setOpen(!open)}>
                <svg viewBox="0 0 100 100" className="menu-svg">
                    <rect x="20" y="20" width="24" height="24" rx="5" />
                    <rect x="56" y="20" width="24" height="24" rx="5" />
                    <rect x="20" y="56" width="24" height="24" rx="5" />
                    <rect x="56" y="56" width="24" height="24" rx="5" />
                </svg>
            </button>

            {open && (
                <div className="menu-box">
                    <button onClick={() => goToPage('home')}>Home</button>
                    <button onClick={() => goToPage('about')}>Over mij</button>
                    <button onClick={() => goToPage('more')}>Mijn visie & openingstijden</button>
                    <button onClick={() => goToPage('daily')}>Dagindeling & Tarieven</button>
                    <button onClick={() => goToPage('illness')}>Ziekte & vakantie</button>
                    <button onClick={() => goToPage('pickup')}>
                        Halen & Brengen
                        <br />
                        Contact & Aansprakelijkheid
                    </button>
                    <button onClick={() => goToPage('exchange')}>Ruildagen & Wenmoment</button>
                </div>
            )}
        </nav>
    );
};

export default SideMenu;